// Import and configure the Stimulus library
import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';

// Start the Stimulus application
const application = Application.start();

// Configure Stimulus development experience
application.debug = import.meta.env.DEV;
window.Stimulus = application;

// Import and register all controller files (e.g. uppy_controller.js -> "uppy")
const controllers = import.meta.glob('./**/*_controller.js', { eager: true });
registerControllers(application, controllers);
